import React from 'react';
import './App.css';
import Header from './header/Header';
import MainContainer from './components/MainContainer';
import Footer from './footer/Footer';
import { StateProvider } from './store';

function App() {
  return (
    <StateProvider>
      <div className="App">
        <Header />
        <MainContainer />
        <Footer />
      </div>
    </StateProvider>
  );
}

export default App;
